const config = {
  colors: {
    primary: '#000000ff',
    background: "#ffffffff",
    // background: "#E2E7D7  ",
    // background: '#414E56',
    secondary: '#010205bc',
    secondaryContrastText: 'white',
    secondaryBackground: '#ffffffff',
     //    secondaryBackground: '#f6e9e9ff',
    dressCodepalette: [
      "#dc6341",
      "#eeb69bff",
      "#e5a4a2",
      "#b9bfe4ff",
      "#baa1e5",
      "#f3d875",
      "#b7bd8f",
      "#a78a84"
    ]
  },
  uripaths: {
    thankYouPath: '/thankyou',
    palenkaPath: '/palenka',
    weddingPartyAfter6PMPath: '/RSVP',
    weddingPartyBefore6PMPath: '/invitation',
    livestreamPath: '/livestream',
    teaPath: '/tea',
  },
};

export default config;